import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01986830"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "aria-hidden": "true" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "neu-tooltip--text tooltipTxt" }, "Manage Census", -1))
const _hoisted_3 = { "aria-hidden": "true" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "neu-tooltip--text tooltipTxt" }, "SMS Notifications", -1))
const _hoisted_5 = ["href"]
const _hoisted_6 = { "aria-hidden": "true" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "neu-tooltip--text tooltipTxt" }, "Go to Facility Scheduler", -1))
const _hoisted_8 = { "aria-hidden": "true" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "neu-tooltip--text tooltipTxt" }, "Contract Labor Management", -1))
const _hoisted_10 = { "aria-hidden": "true" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "neu-tooltip--text tooltipTxt" }, "Preferences", -1))
const _hoisted_12 = { "aria-hidden": "true" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "neu-tooltip--text tooltipTxt" }, "Workforce Request Status", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isManageCensusEnabled)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: "#",
          class: "modaltoolbar neu-tooltip",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadManageCensusPopup && _ctx.loadManageCensusPopup(...args)))
        }, [
          _createElementVNode("i", _hoisted_1, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'users'],
              size: "lg"
            })
          ]),
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("a", {
      href: "#",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showUserSMSNotificationsPopup && _ctx.showUserSMSNotificationsPopup(...args))),
      class: "modaltoolbar neu-tooltip"
    }, [
      _createElementVNode("i", _hoisted_3, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'bell'],
          size: "lg"
        })
      ]),
      _withDirectives(_createElementVNode("span", {
        id: "sms-notifications-count",
        class: "badge notification-count"
      }, _toDisplayString(_ctx.notificationCount), 513), [
        [_vShow, _ctx.isShowNotifictionBadge == true && _ctx.notificationCount > 0]
      ]),
      _hoisted_4
    ]),
    _createElementVNode("a", {
      class: "modaltoolbar neu-tooltip",
      href: _ctx.fsRedirectionLink,
      target: "_blank",
      style: {"cursor":"pointer"}
    }, [
      _createElementVNode("i", _hoisted_6, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'home'],
          size: "lg"
        })
      ]),
      _hoisted_7
    ], 8, _hoisted_5),
    (_ctx.isShowContractLaborManagementModalIcon)
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          href: "#",
          class: "modaltoolbar neu-tooltip",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showContractLaborPopup && _ctx.showContractLaborPopup(...args)))
        }, [
          _createElementVNode("i", _hoisted_8, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'address-card'],
              size: "lg"
            })
          ]),
          _hoisted_9
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("a", {
      href: "#",
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showUserPreferencesPopup && _ctx.showUserPreferencesPopup(...args))),
      class: "modaltoolbar neu-tooltip",
      style: {"cursor":"pointer"}
    }, [
      _createElementVNode("i", _hoisted_10, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'user-circle'],
          size: "lg"
        })
      ]),
      _hoisted_11
    ]),
    (_ctx.isShowSimpleLifecyleReportingModalIcon)
      ? (_openBlock(), _createElementBlock("a", {
          key: 2,
          href: "#",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.showWorkforceRequestStatusPopup && _ctx.showWorkforceRequestStatusPopup(...args))),
          class: "modaltoolbar neu-tooltip",
          style: {"cursor":"pointer"}
        }, [
          _createElementVNode("i", _hoisted_12, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'cogs'],
              size: "lg"
            })
          ]),
          _hoisted_13
        ]))
      : _createCommentVNode("", true)
  ], 64))
}